/**
 * VCC Routes
 */
export const VCC_BASE = "/contact-center";
export const VCC_AGENT_GROUPS = `${VCC_BASE}/agent-groups`;
export const VCC_AGENTS = `${VCC_BASE}/agents`;
export const VCC_AGENT_ASSIGNMENTS = `${VCC_BASE}/agent-assignments`;
export const VCC_SMS_CHANNELS = `${VCC_BASE}/sms-channels`;
export const VCC_PHONE_CHANNELS = `${VCC_BASE}/phone-channels`;
export const VCC_EMAIL_CHANNELS = `${VCC_BASE}/email-channels`;
export const VCC_QUEUES = `${VCC_BASE}/queues`;
export const VCC_TENANT_INFO = `${VCC_BASE}/tenant-info`;

/**
 * Bulk Services Routes
 */
export const BULK_SERVICES = "/bulk-services";
export const PBX = `${BULK_SERVICES}/pbx`;
export const DIAL_PLAN = `${BULK_SERVICES}/dialplan`;
export const LICENSES = `${BULK_SERVICES}/licenses`;

/**
 * Support Tools Routes
 */
export const SUPPORT_TOOLS = "/support";
export const SUPPORT_TOOLS_AUDITS = `${SUPPORT_TOOLS}/audits`;
export const SUPPORT_TOOLS_SMS_CAMPAIGN = `${SUPPORT_TOOLS}/sms-campaign`;
export const SUPPORT_TOOLS_EXTENSIONS_UPDATE = `${SUPPORT_TOOLS}/extensions-update`;
export const SUPPORT_TOOLS_BLFCHECK = `${SUPPORT_TOOLS}/blfcount`;
export const SUPPORT_TOOLS_EMAIL_STATUS = `${SUPPORT_TOOLS}/email-status`;
export const SUPPORT_TOOLS_EMAIL_SUPPRESSION = `${SUPPORT_TOOLS}/email-suppression`;
export const SUPPORT_TOOLS_UNBIND_VMMS = `${SUPPORT_TOOLS}/unbind-vmms`;
export const SUPPORT_TOOLS_DID_CLEANUP = `${SUPPORT_TOOLS}/did-cleanup`;
export const SUPPORT_TOOLS_CSR = `${SUPPORT_TOOLS}/csr`;
export const SUPPORT_TOOLS_ICF = `${SUPPORT_TOOLS}/icf`;
export const SUPPORT_TOOLS_NOMADIC_911 = `${SUPPORT_TOOLS}/nomadic-911`;
export const SUPPORT_TOOLS_DIAL_PLANS = `${SUPPORT_TOOLS}/dial-plans`;
export const SUPPORT_TOOLS_SIP_TRUNK = `${SUPPORT_TOOLS}/sip-trunk`;
export const SUPPORT_TOOLS_ENCRYPT = `${SUPPORT_TOOLS}/encrypt`;
export const SUPPORT_TOOLS_ACCESS_GROUPING = `${SUPPORT_TOOLS}/access-grouping`;

/**
 * Globalization Routes
 */
export const GLOBALIZATION_BASE = `/globalization`;
export const GLOBALIZATION_INTERNATIONAL = `${GLOBALIZATION_BASE}/international`;
export const GLOBALIZATION_INTERNATIONAL_COMPARE = `${GLOBALIZATION_BASE}/international/compare`;
export const GLOBALIZATION_INTERNATIONAL_EDIT_BASE = `${GLOBALIZATION_BASE}/international/edit`;
export const GLOBALIZATION_INTERNATIONAL_EDIT = `${GLOBALIZATION_INTERNATIONAL_EDIT_BASE}/:id`;
export const GLOBALIZATION_SUBNET = `${GLOBALIZATION_BASE}/subnet-list`;

/**
 * Fraud Routes
 */
export const FRAUD_SUPPORT = "/fraud-support";
export const SMS_AUDIT = `${FRAUD_SUPPORT}/sms-audit`;

/**
 * Other Routes
 */
export const JOBS = `/jobs`;
export const TOKEN_GENERATOR = `/token-generator`;
export const TRANSCRIBE = "/transcribe";

export const REACT_APP_ID = "react-app";
